import { FieldWrapper, Label } from '@commenda/kakashi';
import React from 'react';
import {
  EventHandlerActionType,
  NotificationChannel,
  SysEmailRecipientMode,
  TEventHandlerActionDefinition,
} from '@commenda/types';
import { EmailConfigFields } from './EmailConfigFields';

export const DEFAULT_EVENT_HANDLER_ACTION: TEventHandlerActionDefinition = {
  actionType: EventHandlerActionType.NOTIFICATION_SEND,
  config: {
    channel: NotificationChannel.EMAIL,
    templateId: '',
    recipientMode: SysEmailRecipientMode.MATTER_THREAD,
  },
};

type TActionEditorProps = {
  action: TEventHandlerActionDefinition;
  ownerStepId: string;
  fieldsKey: string;
  onChange: (action: TEventHandlerActionDefinition) => void;
};

const ACTION_EDITORS: Record<
  EventHandlerActionType,
  React.ComponentType<TActionEditorProps>
> = {
  [EventHandlerActionType.NOTIFICATION_SEND]: ({
    action,
    ownerStepId,
    fieldsKey,
    onChange,
  }) => (
    <FieldWrapper>
      <Label>Email</Label>
      <EmailConfigFields
        fieldsKey={fieldsKey}
        ownerStepId={ownerStepId}
        config={action.config}
        onChange={(updates) =>
          onChange({ ...action, config: { ...action.config, ...updates } })
        }
      />
    </FieldWrapper>
  ),
};

export const EventHandlerActionEditor = (props: TActionEditorProps) => {
  const Editor = ACTION_EDITORS[props.action.actionType];
  if (!Editor) return null;
  return <Editor {...props} />;
};
